module.exports = __webpack_public_path__ + "img/CR03E.be414b31.png";